import * as sentry from '../../src/utils/sentry'
import { IDB_locationOwnershipsWrite } from '../IDB/IDB.table.locationOwnership'
import { Serv_send } from '../Serv/Serv.socketClient'

export interface Loca_IOwnership {
    locationId: number
    owners: Loca_IOwner[]
}

export interface Loca_IOwner {
    userId: number
    name: string
    teams: string[]
    lastReport?: Date
}

export async function Loca_ownershipSync(
    deps: {
        Serv_send: typeof Serv_send
        IDB_locationOwnershipsWrite: typeof IDB_locationOwnershipsWrite
        sentry: { err: typeof sentry.err }
    } = {
        Serv_send,
        IDB_locationOwnershipsWrite,
        sentry,
    }
) {
    try {
        // Get locations ownerships from server
        let ownershipDtos
        {
            const result = await deps.Serv_send('v2.locations.getOwnerships', {})
            if (result == null || result.locationOwnerships == null || result.locationOwnerships.length === 0) return
            ownershipDtos = result.locationOwnerships
        }

        // Map server structure to client one
        const ownerships: Loca_IOwnership[] = ownershipDtos.map((ownership) => ({
            locationId: ownership.location,
            owners: ownership.owners.map((owner) => ({
                userId: owner.id,
                name: owner.name,
                teams: owner.teams,
                lastReport: owner.lastReportDate == null ? null : new Date(owner.lastReportDate),
            })),
        }))

        // Write to disk
        await deps.IDB_locationOwnershipsWrite(ownerships)
    } catch (error) {
        deps.sentry.err(error, {})
    }
}
